export default __webpack_public_path__ + "static/aws-logo-black-3878495ddb5dbfaad2331513d06fda92.png";